import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app/App'
import * as serviceWorker from './serviceWorker';
import DetectBrowser from "./app/components/quiz/DetectBrowser";

/*const isIE = /!*@cc_on!@*!/false || !!document.documentMode;
// Firefox 1.0+
const isFirefox = typeof InstallTrigger !== 'undefined';
console.log(isIE);
if(isIE) {
    ReactDOM.render(
        <div>Currently there is a problem opening this website in Internet explorer.Please use another browser to perform test.</div>,
        document.getElementById('root'));
}else if(isFirefox){
    console.log(isFirefox);
    ReactDOM.render(
        <div>Currently there is a problem opening this website in Internet explorer.Please use another browser to perform test.</div>,
        document.getElementById('root'));
}
else{
    console.log('other browser');
    /!*ReactDOM.render(<noscript>
        Your browser does not support JavaScript!
    </noscript>, document.getElementById('root'));*!/
    ReactDOM.render(<App />, document.getElementById('root'));
}*/

ReactDOM.render(<App />,document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
